// extracted by mini-css-extract-plugin
module.exports = {"root":"TagLink__root--6JDxi","bounce":"TagLink__bounce--3rnTO"};